import { AnomalyTab } from '../context/AnomalyTabsContext';
import { useAnomaly } from './useAnomaly';

export const useGetAnomalyFromTab = (anomalyTab: AnomalyTab, projectId: number) => {
  const { data, isLoading } = useAnomaly(
    projectId,
    anomalyTab?.anomaly?.id ?? 0,
    !!anomalyTab?.anomaly?.id,
  );

  if (isLoading || !data) {
    return null;
  }

  return data;
};
